import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const formResponse = await getApiData(APIS.FORMS, {});
  Components.addType("vendor-form", {
    isComponent: (el) => {
      if (el.tagName === "main") {
        return {
          type: "vendor-form",
        };
      }
    },
    model: {
      defaults: {
        tagName: "main",
        attributes: {
          class: "vendor-form flex-1 flex items-center justify-center",
        },
        components: /*html*/ `
            <section class="container mx-auto px-4 py-6 ">
              <div class="flex flex-col items-center  justify-center ">

                  <form
                    class="flex flex-col gap-4 w-full md:px-20  p-6 md:py-10  max-w-[700px] rounded-lg shadow-[0px_2px_8px_3px_rgba(0,0,0,0.25)] "
                  >
                    <label class="block">
                      <span class="text-gray-900">Full name*</span>
                      <input
                        type="text"
                        name="full_name"
                        id="full_name"
                        placeholder="eg: (Sam Smith)"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Phone no.*</span>
                      <input
                        type="tel"
                        name="phone_number"
                        id="phone_number"
                        placeholder="eg: (+9779825677664)"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                      />
                    </label>
                    <label class="block">
                      <span class="text-gray-900">Email</span>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="eg: (user@gmail.com)"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded"
                      />
                    </label>
                    <button
                      type="submit"
                      class="bg-purple-700 text-white p-3 mt-3 rounded hover:bg-purple-800 overflow-hidden relative ripple-effect vendor-btn"
                    >
                      <span id="vendor-btn-text">Become a Vendor</span>
                      <div
                         role="status"
                              id="spinner"
                              class="spinner hidden flex justify-center"
                            >
                              <svg
                                aria-hidden="true"
                                class="h-6 w-6 text-gray-200 animate-spin dark:text-gray-600 fill-red-500"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="currentFill"
                                />
                              </svg>
                            </div>
                    </button>
                  </form>
              </div>
            </section>
        `,
        traits: [
          {
            type: "select",
            label: "Select form",
            name: "form-type",
            options: formResponse?.data ?? [],
          },
        ],
        script: function () {
          const formType = document
            .querySelector(".vendor-form")
            .getAttribute("form-type");
          const form = document.querySelector("form") as HTMLFormElement;
          const VendorBtn = document.querySelector(
            ".vendor-btn"
          ) as HTMLButtonElement;
          const VendorBtnText = document.querySelector("#vendor-btn-text");
          const spinner = document.querySelector("#spinner");
          let validator;
          const initLib = function () {
            //@ts-ignore
            validator = new JustValidate(form);
            validator
              .addField(document.querySelector("#full_name"), [
                {
                  rule: "required",
                  errorMessage: "Full name is required",
                },
              ])
              .addField(document.querySelector("#phone_number"), [
                {
                  rule: "required",
                  errorMessage: "Phone number is required",
                },
                {
                  rule: "custom",
                  validator: (value) => /^\+977\d{9,10}$/.test(value),
                  errorMessage: "Enter a valid phone number",
                },
              ]);
          };
          const initToastLib = function () {};
          const showToast = function (toastMessage, color) {
            //@ts-ignore
            Toastify({
              text: `${toastMessage}`,
              duration: 2000,
              close: false,
              gravity: "top",
              position: "right",
              stopOnFocus: true,
              offset: {
                x: 20,
                y: 60,
              },
              style: {
                background: `${color}`,
              },
            }).showToast();
          };

          form.addEventListener("submit", function (e) {
            e.preventDefault();
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => {
              data[key] = value;
            });
            validator.onSuccess((isValid) => {
              if (!isValid) {
                console.log("Form validation failed.");
                return;
              }
              VendorBtn.disabled = true;
              VendorBtnText.classList.add("hidden");
              spinner.classList.remove("hidden");
              fetch("{% url 'save_form' %}", {
                method: "POST",
                body: JSON.stringify({
                  form_data: data,
                  form: formType,
                }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    return Promise.reject("Contactus submission failed.");
                  }
                  return response.json();
                })
                .then(function (result) {
                  console.log("Response:", result);
                  form.reset();
                  showToast("Submitted successfully ", "green");
                })
                .catch(function (error) {
                  console.error("Error submitting checkout:", error);
                })
                .finally(() => {
                  VendorBtnText.classList.remove("hidden");
                  spinner.classList.add("hidden");
                  VendorBtn.disabled = false;
                });
            });
          });
          //@ts-ignore
          if (typeof Toastify === "undefined") {
            const script = document.createElement("script");
            script.onload = initToastLib;
            script.src = "https://cdn.jsdelivr.net/npm/toastify-js";
            document.body.appendChild(script);
          } else {
            initToastLib();
          }
          //@ts-ignore
          if (typeof JustValidate === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://unpkg.com/just-validate@latest/dist/just-validate.production.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
